import { CodecUtils } from 'common/utils/codec-utils';

export enum RoleGroup {
  Employee = 'Employee',
  Guest = 'Guest',
  Subcontractor = 'Subcontractor',
}

export const RoleGroupC = CodecUtils.createEnumCodec<RoleGroup>(RoleGroup, 'RoleGroup');
